module.exports = __webpack_public_path__ + "static/media/SDFSA_4-509w.501838ed.jpg";